import type { Styles } from 'src/theme/themes';

export const styles = {
  // Bar
  barContainer: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'end',
    gap: 1,
    width: '5rem',
  },
  barData: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'end',
  },
  barStack: {
    borderLeft: 'solid 4px',
    minHeight: 'max-content',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  barLabel: {
    height: '2.5rem',
    textAlign: 'center',
    whiteSpace: 'wrap',
    fontWeight: 600,
    overflowY: 'auto',
  },
  comparisonPill: (theme) => ({
    alignSelf: 'flex-start',
    marginBottom: theme.spacing(0.5),
  }),
} satisfies Styles;
